import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import Swal from "sweetalert2";
import FileUpload from "../helper/FileUpload";
import { fetchData } from "../helper/api.interceptor";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

const AddProduct = () => {
    const navigate = useNavigate();

    const [productName, setProductName] = useState("");
    const [productDesc, setProductDesc] = useState("");
    const [productSize, setProductSize] = useState("");
    const [productDetailsPage, setProductDetailsPage] = useState("");
    const [mainPrice, setMainPrice] = useState("");
    const [afterDiscountPrice, setAfterDiscountPrice] = useState("");
    // const [_projectImages, setProjectImages] = useState([]);
    const [heroVideo, setHeroVideo] = useState([]);
    const [productListingImage, setProductListingImage] = useState([]);
    const [whyChooseUs, setWhyChooseUs] = useState([
        { feature_name: "", feature_dec: "" },
    ]);
    const [loading, setLoading] = useState(false);
    const [productTypes, setProductTypes] = useState([]);

    // ✅ New state variables for the additional image fields - ensure they're arrays
    // const [mainImages, setMainImages] = useState([]);
    // const [newArrivalListImages, setNewArrivalListImages] = useState([]);
    // const [placeOrderImages, setPlaceOrderImages] = useState([]);

    // ✅ New validation state for image limits
    // const [imageErrors, setImageErrors] = useState({
    //     newArrivalList: "",
    //     placeOrderImages: ""
    // });

    // Existing handlers
    // const handleFileSelect = (files) => {
    //     setProjectImages(files);
    // };

    // ✅ Handler for mainImages
    // const handleMainImagesSelect = (files) => {
    //     setMainImages(files);
    // };

    // ✅ Handler for newArrivalListImages with validation (max 2)
    // const handleNewArrivalListSelect = (files) => {
    //     // Ensure files is an array
    //     const filesArray = Array.isArray(files) ? files : [files].filter(Boolean);

    //     if (filesArray.length > 2) {
    //         setImageErrors(prev => ({
    //             ...prev,
    //             newArrivalList: "Maximum 2 images allowed for New Arrival List"
    //         }));
    //         // Take only first 2 images
    //         setNewArrivalListImages(filesArray.slice(0, 2));
    //     } else {
    //         setImageErrors(prev => ({ ...prev, newArrivalList: "" }));
    //         setNewArrivalListImages(filesArray);
    //     }
    // };

    // ✅ Handler for placeOrderImages with validation (max 1)
    // const handlePlaceOrderImagesSelect = (files) => {
    //     // Ensure files is an array (handle both single file and array)
    //     const filesArray = Array.isArray(files) ? files : [files].filter(Boolean);

    //     if (filesArray.length > 1) {
    //         setImageErrors(prev => ({
    //             ...prev,
    //             placeOrderImages: "Maximum 1 image allowed for Place Order"
    //         }));
    //         // Take only first image
    //         setPlaceOrderImages(filesArray.slice(0, 1));
    //     } else {
    //         setImageErrors(prev => ({ ...prev, placeOrderImages: "" }));
    //         setPlaceOrderImages(filesArray);
    //     }
    // };

    const handleTypeChange = (type) => {
        setProductTypes((prev) =>
            prev.includes(type)
                ? prev.filter((t) => t !== type)
                : [...prev, type]
        );
    };

    const addFeature = () => {
        setWhyChooseUs([...whyChooseUs, { feature_name: "", feature_dec: "" }]);
    };

    const updateFeature = (index, field, value) => {
        const updated = [...whyChooseUs];
        updated[index][field] = value;
        setWhyChooseUs(updated);
    };

    const removeFeature = (index) => {
        if (whyChooseUs.length > 1) {
            setWhyChooseUs(whyChooseUs.filter((_, i) => i !== index));
        }
    };

    // ✅ Helper function to safely append files to FormData
    // const appendFilesToFormData = (formData, fieldName, files) => {
    //     if (!files || files.length === 0) return;

    //     // Ensure files is an array
    //     const filesArray = Array.isArray(files) ? files : [files].filter(Boolean);

    //     filesArray.forEach((file) => {
    //         if (file) {
    //             formData.append(fieldName, file);
    //         }
    //     });
    // };

    const handleSubmit = async () => {
        if (
            !productName ||
            !productDesc ||
            !productSize ||
            !productDetailsPage ||
            !mainPrice ||
            !afterDiscountPrice ||
            !heroVideo[0]?.file
        ) {
            Swal.fire({
                icon: "warning",
                title: "Missing Fields",
                text: "Please fill all required fields and upload a hero video.",
            });
            return;
        }

        setLoading(true);

        try {
            const formData = new FormData();

            // ✅ Only common fields (NO IMAGES)
            formData.append("product_name", productName);
            formData.append("product_desc", productDesc);
            formData.append("product_size", productSize);
            formData.append("product_details_page", productDetailsPage);
            formData.append("main_price", mainPrice);
            formData.append("after_discount_price", afterDiscountPrice);
            formData.append("why_choose_us", JSON.stringify(whyChooseUs));
            formData.append("type", JSON.stringify(productTypes));
            formData.append("hero_video", heroVideo[0].file);
            if (productListingImage[0]?.file) {
                formData.append("product_listing_image", productListingImage[0].file);
            }

            const result = await fetchData.postWithFormData("product/add", formData);

            if (result?.status_code === 200) {
                Swal.fire({
                    icon: "success",
                    title: "Success!",
                    text: "Product added successfully!",
                    confirmButtonColor: "#28a745",
                }).then(() => {
                    const productId = result.result?.productId;
                    if (productId) {
                        navigate(`/product/add-color-variant/${productId}`);
                    } else {
                        navigate("/product_details");
                    }
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: result?.message || "Failed to add product.",
                });
            }
        } catch (error) {
            console.error("Error adding product:", error);
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong while adding the product.",
            });
        } finally {
            setLoading(false);
        }
    };
    return (
        <div>
            {/* Breadcrumb */}
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-4">
                <h6 className="fw-semibold mb-0">Add Product</h6>
                <ul className="d-flex align-items-center gap-2">
                    <li className="fw-medium">
                        <Link
                            to="/product_details"
                            className="d-flex align-items-center gap-1 hover-text-primary"
                        >
                            <Icon icon="solar:home-smile-angle-outline" className="icon text-lg" />
                            Product Details
                        </Link>
                    </li>
                    <li> - </li>
                    <li className="fw-medium">Add Product</li>
                </ul>
            </div>

            <div className="card">
                <div className="card-header d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <h6 className="fw-semibold mb-0">New Product</h6>
                    <button
                        className="btn btn-outline-secondary d-flex align-items-center gap-2"
                        onClick={() => navigate(-1)}
                    >
                        <Icon icon="mdi:arrow-left" /> Back
                    </button>
                </div>

                <div className="card-body">
                    {/* Product Details */}
                    <div className="mb-3">
                        <label className="form-label fw-semibold">Product Name</label>
                        <input
                            type="text"
                            className="form-control"
                            value={productName}
                            onChange={(e) => setProductName(e.target.value)}
                            placeholder="Enter product name"
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label fw-semibold">Product Description</label>
                        <textarea
                            className="form-control"
                            rows={3}
                            value={productDesc}
                            onChange={(e) => setProductDesc(e.target.value)}
                            placeholder="Enter product description"
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label fw-semibold">Product Size</label>
                        <input
                            type="text"
                            className="form-control"
                            value={productSize}
                            onChange={(e) => setProductSize(e.target.value)}
                            placeholder="Enter product size"
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label fw-semibold">Product Details Page</label>
                        <textarea
                            className="form-control"
                            rows={4}
                            value={productDetailsPage}
                            onChange={(e) => setProductDetailsPage(e.target.value)}
                            placeholder="Enter product details page content"
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label fw-semibold">Main Price</label>
                        <input
                            type="number"
                            className="form-control"
                            value={mainPrice}
                            onChange={(e) => setMainPrice(e.target.value)}
                            placeholder="Enter main price"
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label fw-semibold">After Discount Price</label>
                        <input
                            type="number"
                            className="form-control"
                            value={afterDiscountPrice}
                            onChange={(e) => setAfterDiscountPrice(e.target.value)}
                            placeholder="Enter discounted price"
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label fw-semibold">Product Type</label>
                        <div className="d-flex gap-4 flex-wrap">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={productTypes.includes("New Arrivals")}
                                        onChange={() => handleTypeChange("New Arrivals")}
                                        sx={{
                                            color: "#696969",
                                            "&.Mui-checked": { color: "#696969" },
                                        }}
                                    />
                                }
                                label="New Arrivals"
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={productTypes.includes("Bestsellers")}
                                        onChange={() => handleTypeChange("Bestsellers")}
                                        sx={{
                                            color: "#696969",
                                            "&.Mui-checked": { color: "#696969" },
                                        }}
                                    />
                                }
                                label="Bestsellers"
                            />
                        </div>
                    </div>


                    <div className="mb-3 mt-4">
                        <FileUpload
                            label="Hero Video"
                            multiple={false}
                            maxFiles={1}
                            accept={{ "video/*": [] }}
                            fileType="video"
                            images={heroVideo}
                            onImagesChange={setHeroVideo}
                        />
                    </div>

                    <div className="mb-3 mt-4">
                        <FileUpload
                            label="Product Listing Image"
                            multiple={false}
                            maxFiles={1}
                            images={productListingImage}
                            onImagesChange={setProductListingImage}
                        />
                    </div>

                    {/* ✅ New: Main Images */}
                    {/* <div className="mb-3 mt-4">
                        <FileUpload
                            label="Main Images"
                            multiple
                            onFilesSelected={handleMainImagesSelect}
                            note="Multiple images allowed. These will be saved as mainImages in backend"
                        />
                    </div> */}

                    {/* ✅ New: New Arrival List Images */}


                    {/* Why Choose Us Features */}
                    <div className="mb-3 mt-4">
                        <label className="form-label fw-semibold">Why Choose Us</label>
                        {whyChooseUs.map((feature, index) => (
                            <div key={index} className="border rounded p-3 mb-3">
                                <div className="row g-2">
                                    <div className="col-md-5">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Feature Name"
                                            value={feature.feature_name}
                                            onChange={(e) =>
                                                updateFeature(index, "feature_name", e.target.value)
                                            }
                                            required
                                        />
                                    </div>
                                    <div className="col-md-5">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Feature Description"
                                            value={feature.feature_dec}
                                            onChange={(e) =>
                                                updateFeature(index, "feature_dec", e.target.value)
                                            }
                                            required
                                        />
                                    </div>
                                    <div className="col-md-2 d-flex align-items-center">
                                        {whyChooseUs.length > 1 && (
                                            <button
                                                type="button"
                                                className="btn bg-custom px-16"
                                                onClick={() => removeFeature(index)}
                                            >
                                                Remove
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                        <button
                            type="button"
                            className="btn addfeature"
                            onClick={addFeature}
                        >
                            + Add Feature
                        </button>
                    </div>

                    <div className="d-flex gap-3 mt-4">
                        <button
                            className="btn bg-custom px-16"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            {loading ? "Saving..." : "Save and Add color variants"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddProduct;
